
export default function TermsConditions() {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
        <h1 className="text-3xl sm:text-4xl font-bold text-[#0A1628] mb-8">Términos y Condiciones</h1>
        
        <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
          <p className="text-sm text-gray-500">Última actualización: 6 de febrero de 2026</p>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">1. Aceptación de los Términos</h2>
            <p>
              Al acceder y utilizar el sitio web de PreBedAI (https://prebedai.com), usted acepta cumplir 
              y estar sujeto a estos Términos y Condiciones. Si no está de acuerdo con alguno de estos términos, 
              no debe utilizar nuestro sitio web.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">2. Descripción del Servicio</h2>
            <p>
              PreBedAI ofrece una plataforma de gestión inteligente de camas y altas hospitalarias mediante 
              inteligencia artificial. Nuestros servicios incluyen:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Predicción de altas hospitalarias</li>
              <li>Gestión automatizada de camas</li>
              <li>Coordinación de equipos hospitalarios</li>
              <li>Integración con sistemas HIS/ERP</li>
              <li>Reporting y analytics en tiempo real</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">3. Uso del Sitio Web</h2>
            <p>El usuario se compromete a:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Utilizar el sitio web de conformidad con la ley y estos Términos</li>
              <li>No utilizar el sitio con fines fraudulentos o ilegales</li>
              <li>No intentar acceder a áreas restringidas del sitio</li>
              <li>No transmitir virus, malware o código malicioso</li>
              <li>No realizar ingeniería inversa, descompilar o desensamblar cualquier parte del servicio</li>
              <li>Proporcionar información veraz y actualizada en los formularios</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">4. Propiedad Intelectual</h2>
            <p>
              Todos los contenidos del sitio web, incluyendo pero no limitándose a textos, gráficos, logotipos, 
              iconos, imágenes, clips de audio, descargas digitales y compilaciones de datos, son propiedad de 
              PreBedAI o de sus proveedores de contenido y están protegidos por las leyes de propiedad intelectual 
              españolas e internacionales.
            </p>
            <p className="mt-4">
              Queda prohibida la reproducción, distribución, comunicación pública y transformación de los contenidos 
              sin el consentimiento expreso y por escrito de PreBedAI.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">5. Registro y Cuenta de Usuario</h2>
            <p>
              Para acceder a ciertos servicios, puede ser necesario crear una cuenta. El usuario es responsable de:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Mantener la confidencialidad de sus credenciales</li>
              <li>Todas las actividades que ocurran bajo su cuenta</li>
              <li>Notificar inmediatamente cualquier uso no autorizado</li>
              <li>Proporcionar información precisa, actual y completa</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">6. Precios y Pagos</h2>
            <p>
              Los precios de nuestros servicios se especifican en la página de precios y pueden estar sujetos a cambios. 
              Todos los precios incluyen IVA cuando sea aplicable.
            </p>
            <p className="mt-4">
              Las condiciones específicas de contratación, facturación y pago se establecerán en el contrato 
              particular con cada cliente.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">7. Garantías y Limitación de Responsabilidad</h2>
            <p>
              PreBedAI proporciona sus servicios "tal cual" y "según disponibilidad". En la medida permitida por la ley:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>No garantizamos que el servicio sea ininterrumpido o libre de errores</li>
              <li>No seremos responsables de daños indirectos, incidentales o consecuentes</li>
              <li>Nuestra responsabilidad no excederá el importe pagado por el servicio</li>
              <li>El usuario es responsable de la evaluación de la exactitud de cualquier contenido obtenido</li>
            </ul>
            <p className="mt-4 font-bold">
              PreBedAI es una herramienta de apoyo a la decisión. Las decisiones finales sobre gestión de pacientes 
              siempre deben ser tomadas por profesionales sanitarios cualificados.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">8. Protección de Datos</h2>
            <p>
              El tratamiento de datos personales se realiza conforme a nuestra 
              <a href="/politica-privacidad" className="text-[#6D28D9] hover:underline ml-1">Política de Privacidad</a>, 
              en cumplimiento del RGPD y LOPDGDD.
            </p>
            <p className="mt-4">
              PreBedAI implementa medidas técnicas y organizativas apropiadas para garantizar la seguridad de los datos, 
              especialmente cuando se trata de datos de salud considerados de categoría especial.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">9. Enlaces a Terceros</h2>
            <p>
              Nuestro sitio web puede contener enlaces a sitios web de terceros. PreBedAI no tiene control sobre 
              el contenido, políticas de privacidad o prácticas de sitios web de terceros y no asume responsabilidad 
              por ellos.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">10. Modificaciones</h2>
            <p>
              PreBedAI se reserva el derecho de modificar estos Términos y Condiciones en cualquier momento. 
              Las modificaciones entrarán en vigor en el momento de su publicación en el sitio web. 
              El uso continuado del sitio después de cualquier cambio constituye su aceptación de los nuevos términos.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">11. Resolución de Disputas</h2>
            <p>
              Estos Términos se rigen por las leyes de España. Para la resolución de cualquier controversia, 
              las partes se someten a los Juzgados y Tribunales de [Ciudad], renunciando expresamente a cualquier 
              otro fuero que pudiera corresponderles.
            </p>
            <p className="mt-4">
              De conformidad con el Reglamento (UE) 524/2013, la Comisión Europea facilita una plataforma de 
              resolución de litigios en línea disponible en: 
              <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-[#6D28D9] hover:underline ml-1">
                https://ec.europa.eu/consumers/odr
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">12. Severabilidad</h2>
            <p>
              Si alguna disposición de estos Términos se considera inválida o inaplicable, las disposiciones 
              restantes seguirán en pleno vigor y efecto.
            </p>
          </section>

          <section className="mt-12 p-6 bg-gray-50 rounded-lg">
            <h3 className="text-xl font-bold text-[#0A1628] mb-4">Contacto</h3>
            <p>
              Para cualquier pregunta sobre estos Términos y Condiciones, puede contactarnos en:
            </p>
            <ul className="mt-4 space-y-2">
              <li><strong>Email:</strong> <a href="mailto:info@prebedai.com" className="text-[#6D28D9] hover:underline">info@prebedai.com</a></li>
              <li><strong>Web:</strong> <a href="https://prebedai.com" className="text-[#6D28D9] hover:underline">https://prebedai.com</a></li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
}
